import publicService from '../../api/public'
import locationService from './service.js'

export default {
  namespaced: true,
  state: {
    locations: [],
    service: {
      pos: null,
      reconcile: null,
      commercial: null,
    },
    cards: [],
    location: null,
    signUp: null,
    deals: [],
    feature: [],
    order: [],
    Hardware: [],
    shipping: 10,
    Store: {
      businessName: null,
      phoneNumber: null,
      address: null,
      city: null,
      stateID: null,
      zipcode: null,
      country: null,
      businessEmail: null,
      invoiceEmail: null,
    },
    Card: {
      cardNumber: null,
      nameOnCard: null,
      cvvCode: null,
      cardExpiry: null,
      address: null,
      city: null,
      state: null,
      zipcode: null,
    },
    Plans: {
      selectedModules: [1],
      package: 2,
      softwareFee: 80,
    },
    Review: {
      terms: false,
    },
  },
  getters: {
    locations(state) {
      return state.locations
    },
    service(state) {
      return state.service
    },
    review(state) {
      return state.Review
    },
    signUp(state) {
      return state.signUp
    },
    cards(state) {
      return state.cards
    },
    location(state) {
      return state.location
    },
    store(state) {
      return state.Store
    },
    card(state) {
      return state.Card
    },
    feature(state) {
      return state.feature
    },
    order(state) {
      return state.order
    },
    shipping(state) {
      return state.shipping
    },
    hardwareTotal(state) {
      let amount = 0
        state.Hardware.forEach(row => {
          let value = row.order * row.amount
          amount = amount + value
        })
      if (amount !== 0) {
        if (amount <= 399) {
          amount = amount + 10
        }
      }
      return amount
    },
    hardware(state) {
      return state.Hardware
    },
    deals(state) {
      return state.deals
    },
    plans(state) {
      return state.Plans
    },
  },
  actions: {
    setLocationList({ commit }, payload) {
      commit('setLocationList', payload)
    },
    setReconcile({ commit }, payload) {
      commit('setReconcile', payload)
    },
    setPos({ commit }, payload) {
      commit('setPos', payload)
    },
    setCommercial({ commit }, payload) {
      commit('setCommercial', payload)
    },
    resetLocation({ commit }) {
      commit('resetLocation')
    },
    setCard({ commit }, payload) {
      commit('setCard', payload)
    },
    setLocation({ commit }, id) {
      return locationService.getbyId(id)
      .then((response) => {
        commit('resetService')
        console.log('location', response)
        response.ProductRelations.map(x => {
          if (x.serviceID === 192) commit('setPos', x)
          if (x.serviceID === 193) commit('setReconcile', x)
          if (x.serviceID === 194) commit('setCommercial', x)
        })
        commit('setLocation', response)
      })
    },
    setSignUp({ commit }, payload) {
      commit('setSignUp', payload)
    },
    addItem({ commit }, index) {
      commit('addItem', index)
    },
    removeItem({ commit }, index) {
      commit('removeItem', index)
    },
    initHardware({ commit }) {
      return publicService.Hardware()
        .then((response) => {
          commit('initHardware', response.data)
        })
    },
    loadDeals({ state, commit }) {
      let deals = []
      if (state.Plans.package === 1) {
        // 'Repair', 'BillPayment', 'TimeClock',
        deals = ['Repair', 'BillPayment', 'TimeClock', 'Hardware', 'Promotion', 'Review']
        state.Plans.selectedModules.forEach(row => {
          if (row === 11) {
            var index = deals.indexOf('TimeClock');    // <-- Not supported in <IE9
            if (index !== -1) {
              deals.splice(index, 1);
            }
          }
          if (row === 3) {
            var index = deals.indexOf('BillPayment');    // <-- Not supported in <IE9
            if (index !== -1) {
              deals.splice(index, 1);
            }
          }
          if (row === 4) {
            var index = deals.indexOf('Repair');    // <-- Not supported in <IE9
            if (index !== -1) {
              deals.splice(index, 1);
            }
          }
        })
      } else {
        deals = ['Hardware', 'Promotion', 'Review']
        // ['Hardware', 'Promotion']
      }
      commit('loadDeals', deals)
    },
    order({ commit }, payload) {
      commit('order', payload)
      commit('removeDeal')
    },
    feature({ commit }, payload) {
      commit('feature', payload)
      commit('removeDeal')
    },
    removeDeal({ commit }) {
      commit('removeDeal')
    },
  },
  mutations: {
    setLocationList(state, payload) {
      state.locations = payload
    },
    resetService(state) {
      state.service.reconcile = null
      state.service.commercial = null
      state.service.pos = null
    },
    setReconcile(state, payload) {
      state.service.reconcile = payload
    },
    setCommercial(state, payload) {
      state.service.commercial = payload
    },
    setPos(state, payload) {
      state.service.pos = payload
    },
    resetLocation(state) {
      state.Store = {
        businessName: null,
        phoneNumber: null,
        address: null,
        city: null,
        stateID: null,
        zipcode: null,
        country: null,
        businessEmail: null,
        invoiceEmail: null,
      }
      state.Card = {
        cardNumber: null,
        nameOnCard: null,
        cvvCode: null,
        cardExpiry: null,
        address: null,
        city: null,
        state: null,
        zipcode: null,
      }
      state.Plans = {
        selectedModules: [1],
        package: 2,
        softwareFee: 80,
      }
      state.Review = {
        terms: false,
      }
    },
    setCard(state, payload) {
      state.cards.push(payload)
    },
    setLocation(state, payload) {
      state.location = payload
    },
    setSignUp(state, payload) {
      state.signUp = payload
    },
    addItem(state, index) {
      const oldOrder = state.Hardware[index].order
      state.Hardware[index].order = oldOrder + 1
    },
    removeItem(state, index) {
      const oldOrder = state.Hardware[index].order
      state.Hardware[index].order = oldOrder - 1
    },
    initHardware(state, payload) {
      payload.forEach(row => {
        row.order = 0
      })
      state.Hardware = payload
    },
    order(state, payload) {
      state.order.push(payload)
    },
    feature(state, payload) {
      state.feature.push(payload)
    },
    removeDeal(state) {
      state.deals.shift()
    },
    loadDeals(state, payload) {
      state.deals = payload
    },
  },
}
